import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

import type { ChatbotChannel } from '../../model/types';

export interface ResetScopeDialogProps {
  open: boolean;
  channel: ChatbotChannel;
  onConfirm: () => void;
  onCancel: () => void;
}

/** "Reset to general?" confirmation for a card that has unsaved override edits (design §7.3). */
export function ResetScopeDialog({ open, channel, onConfirm, onCancel }: ResetScopeDialogProps) {
  const { t } = useTranslation('chatbot');
  const channelLabel = t(`scope.${channel.toLowerCase()}`);

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t('scope.resetDialog.title', { channel: channelLabel })}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('scope.resetDialog.body', { channel: channelLabel })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} autoFocus>
          {t('common:action.cancel')}
        </Button>
        <Button onClick={onConfirm} color="error">
          {t('scope.resetToGeneral')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
